import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  TablePagination,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormGroup,
  Switch,
  TextField
} from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { SIREN_CONFIG, SIREN_COLOR } from "config.js";
import DateFnsUtils from '@date-io/date-fns'; //yarn add date-fns
import moment from 'moment';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker
} from '@material-ui/pickers';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  updateQueryStartDate,
  updateQueryStartTime,
  updateQueryEndDate,
  updateQueryEndTime,
  updateQueryEmergencyRoomId,
  updateQueryCheckEmergency,
  updateQueryCheckCaution,
  updateQueryCheckCompleted} from 'actions/query';

import { updateRowsPerPageEmergencyHistories } from 'actions/rows';
import {useSelector} from 'react-redux';

import { loadRoomList } from "utils/LoadConfiguration";
import { FormattedMessage, useIntl } from "react-intl";



const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '16px',
      },
    },
  },
})


const EmergencyTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.EMERGENCY_BG2_COLOR,
  }
})(Typography);


const CautionTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.CAUTION_BG2_COLOR,
  }
})(Typography);


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  // console.log("order : " + order + " , orderBy: " + orderBy);
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const COLUMN_WIDTH = {
  NO: '5%',
  ROOM_NAME: '20%',
  STATUS_LABEL: '10%', //35
  FIRST_EVENTTIME: '10%', //45
  OCCURFROM: '10%', //55
  ACTION_USER: '10%', //65
  ACTION: '25%', //90
  ACTIONTIMESTAMP: '10%', //100
}

const headCells = [
  { id:'no', numeric: false, label: 'No', width: COLUMN_WIDTH.NO , align:'center'},
  { id:'roomName', numeric: false, label: <FormattedMessage id="emergency_history_room" />, width: COLUMN_WIDTH.ROOM_NAME, align:'center'},
  { id:'status_Label', numeric: false, label:  <FormattedMessage id="emergency_history_status" />, width: COLUMN_WIDTH.STATUSLABEL, align:'center'},
  { id:'first_eventTime', numeric: false, label:  <FormattedMessage id="emergency_history_occurTime" />, width: COLUMN_WIDTH.FIRST_EVENTTIME, align:'center'},
  { id:'occurFrom', numeric: false, label:  <FormattedMessage id="emergency_history_occurFrom" />, width: COLUMN_WIDTH.OCCURFROM, align:'center'},
  { id:'action_user', numeric: false, label:  <FormattedMessage id="emergency_history_actor" />, width: COLUMN_WIDTH.ACTION_USER, align:'center'},
  { id:'action', numeric: false, label:  <FormattedMessage id="emergency_history_action" />, width: COLUMN_WIDTH.ACTION, align:'center'},
  { id:'actionTimeStamp', numeric: false, label:  <FormattedMessage id="emergency_history_actionTime" />, width: COLUMN_WIDTH.ACTIONTIMESTAMP, align:'center'},
  // { id:'roomName', numeric: false, label: '병실', width: COLUMN_WIDTH.ROOM_NAME, align:'center'},
  // { id:'statusLabel', numeric: false, label: '상태', width: COLUMN_WIDTH.STATUSLABEL, align:'center'},
  // { id:'first_eventTime', numeric: false, label: '발생일시', width: COLUMN_WIDTH.FIRST_EVENTTIME, align:'center'},
  // { id:'occurFrom', numeric: false, label: '감지처', width: COLUMN_WIDTH.OCCURFROM, align:'center'},
  // { id:'action_user', numeric: false, label: '조치자', width: COLUMN_WIDTH.ACTION_USER, align:'center'},
  // { id:'action', numeric: false, label: '조치내용', width: COLUMN_WIDTH.ACTION, align:'center'},
  // { id:'actionTimeStamp', numeric: false, label: '조치시각', width: COLUMN_WIDTH.ACTIONTIMESTAMP, align:'center'},
];


function EnhancedTableHeader(props) {

  const {classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  }


  return (

    <TableHead>
      <TableRow>
        {
        headCells.map( (headCell) => (
          <TableCell key={headCell.id}
          // align={headCell.numeric ? 'right': 'left'}
          align={headCell.align}
          width={headCell.width}
          sortDirection={orderBy === headCell.id ? order : false}
          >

            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? '' : ''}
                </span>
              ) : null}
              </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

  );
}

EnhancedTableHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired
}


const StartDateDefaultValue = new Date( (new Date()).valueOf() - (1000 * 60 * 60 * 24) );
const StartTimeDefaultValue = new Date( (new Date()).valueOf() - (1000 * 60 * 60 * 24) );

const EndDateDefaultValue = new Date();
const EndTimeDefaultValue = new Date();


const EmergencyList = props => {
  const { className, users, queryParams, queryRowsPerPage, ...rest } = props;

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('occurTime');

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [startDate, setStartDate] = useState( '' );
  const [startTime, setStartTime] = useState(StartTimeDefaultValue);

  const [endDate, setEndDate] = useState( '' );
  const [endTime, setEndTime] = useState(EndTimeDefaultValue);

  const [listData, setListData] = useState([]);

  const [checkedEmergency, setCheckedEmergency] = useState(true);
  const [checkedCaution, setCheckedCaution] = useState(true);
  const [checkedCompleted, setCheckedCompleted] = useState(false);

  const facility_id = useSelector((store) => store.user.facility_id);
  const [roomList, setRoomList] = useState([]);
  const [selectedRoomId, setSelectedRoomId] = useState('ALL');


  const getRoomName = (roomId) => {
    var ret = {};
    roomList.forEach(room => {
      if (room.roomId === roomId) {
        ret = { roomId: room.roomId, roomName: room.roomName };
      }
    });
    return ret;
  }


  const handleStartDateChange = (date) => {
    setStartDate(date);
    props.updateQueryStartDate(date);
  }

  const handleStartTimeChange = (value) => {
    setStartTime(value);
    props.updateQueryStartTime(value);
  }

  const handleEndDateChange = (value) => {
    setEndDate(value);
    props.updateQueryEndDate(value);
  }

  const handleEndTimeChange = (value) => {
    setEndTime(value);
    props.updateQueryEndTime(value);
  }


  const searchData = (sDate, sTime, eDate, eTime, roomId, isEmergency, isCaution, isCompleted) => {

    //check parameters
    if (roomId === '') {
      alert(formatMessage({ id: "select_room" }));
      return;
    }

    if (checkedEmergency == false && checkedCaution == false){
      alert(formatMessage({id:'should_select_emergency_or_caution'}));
      return false;
    }


    let url = `${SIREN_CONFIG.HOSTNAME}/emergency/queryEmergencyList`;

    let params = {
      // startDate: moment(sDate).format('YYYY-MM-DD') + ' 00:00:00',
      // endDate: moment(eDate).format('YYYY-MM-DD') + ' 23:59:59',
      facility_id: facility_id,
      startDate: moment(sDate).format('YYYY-MM-DD') + ' ' + sTime ,
      endDate: moment(eDate).format('YYYY-MM-DD') + ' ' + eTime,
      roomId: roomId !== 'ALL' ? roomId : '',
      isEmergency: isEmergency,
      isCaution: isCaution,
      isCompleted: isCompleted
    };

    url += '?' + (new URLSearchParams( params)).toString();


    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
      }
    )
    .then( (response) => { return response.json(); })
    .then( (responseData) => {

      var list = [];
      var no = 1;

      if(responseData.resultCode === '000'){

        responseData.resultData.map( row => {
          row.no = no++;
          list.push(row);
        });
      }else{
        //params error
        alert(formatMessage({id:'wrong_parameters'}) + ': ' + JSON.stringify(responseData) );
      }


      //자료가 없으면 alert 메시지 표시
      if (list.length  == 0) {
        alert(formatMessage({id:'not_data'}));
      }

      setListData(list);
      setPage(0);
    })
    .catch( error => {
      console.error(`Error Occur:`, error);
      alert('Error! ' + error.message)
    });

  }


  useEffect(() => {
    //NOTE: DB에 부하가 발생하므로, 이전에 입력한 파라미터만 화면에 표시하고, DB 조회는 하지 아니함.

    if (queryRowsPerPage.emergencyHistoriesRowsPerPage.length == 0){
      props.updateRowsPerPageEmergencyHistories(10);
    } else {
      setRowsPerPage( queryRowsPerPage.emergencyHistoriesRowsPerPage );
    }

    if (queryParams.queryStartDate == ''){
      props.updateQueryStartDate( StartDateDefaultValue );
      setStartDate( StartDateDefaultValue );
    } else {
      setStartDate(queryParams.queryStartDate);
    }

    if (queryParams.queryStartTime == ''){
      props.updateQueryStartTime( StartTimeDefaultValue );
      setStartTime( StartTimeDefaultValue );
    } else {
      setStartTime( queryParams.queryStartTime );
    }

    if (queryParams.queryEndDate == ''){
      props.updateQueryEndDate( EndDateDefaultValue );//today as default
      setEndDate( EndDateDefaultValue );
    } else {
      setEndDate(queryParams.queryEndDate);
    }

    if (queryParams.queryEndTime == ''){
      props.updateQueryEndTime( EndTimeDefaultValue );
      setEndTime( EndTimeDefaultValue );
    } else {
      setEndTime( queryParams.queryEndTime );
    }

    if (queryParams.queryEmergencyRoomId === ''){
      setSelectedRoomId('');
      props.updateQueryEmergencyRoomId('');
    } else {
      setSelectedRoomId(queryParams.queryEmergencyRoomId);
    }

    setCheckedEmergency(queryParams.queryCheckEmergency);
    setCheckedCaution(queryParams.queryCheckCaution);
    setCheckedCompleted(queryParams.queryCheckCompleted);


    // //이전에 입력한 검색값이 있으면, 검색결과를 화면에 표시함.
    // if ( (queryParams.queryStartDate && queryParams.queryEndDate
    //     && queryParams.queryStartTime && queryParams.queryEndTime ) ||
    //   queryParams.queryCheckEmergency || queryParams.queryCheckCaution || queryParams.queryCheckCompleted){


    //   let sTime = "00:00";
    //   try{
    //     sTime = moment(queryParams.queryStartTime).format('HH:mm');
    //     searchData(queryParams.queryStartDate, sTime,
    //       queryParams.queryEndDate, queryParams.queryEndTime,
    //       queryParams.queryCheckEmergency, queryParams.queryCheckCaution, queryParams.queryCheckCompleted);
    //   }catch(err){
    //     alert('wrong time');
    //   }
    // }


    async function loadRoomInfo() {
      const list = await loadRoomList(facility_id);
      var list2= [{ roomId: 'ALL', roomName: 'ALL' }, ...list];

      setRoomList(list2);
    }
    loadRoomInfo();

    return () => { };
  }, []);



  const handleSearch = event => {

    let sTime = "00:00";
    let eTime = "23:59";
    try{
      sTime = moment(startTime).format('HH:mm');
      eTime = moment(endTime).format('HH:mm');
      searchData(startDate, sTime, endDate, eTime, selectedRoomId, checkedEmergency, checkedCaution, checkedCompleted);
    }catch(err){
      alert('wrong time');
    }
  }



  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    //오늘
    props.updateQueryStartDate( StartDateDefaultValue );
    setStartDate( StartDateDefaultValue );

    props.updateQueryStartTime( StartTimeDefaultValue );
    setStartTime( StartTimeDefaultValue );

    props.updateQueryEndDate( EndDateDefaultValue );
    setEndDate( EndDateDefaultValue );

    props.updateQueryEndTime( EndTimeDefaultValue );
    setEndTime( EndTimeDefaultValue );

    props.updateQueryEmergencyRoomId('');
    setSelectedRoomId('');

    props.updateQueryCheckEmergency(false);
    setCheckedEmergency(false);

    props.updateQueryCheckCaution(false);
    setCheckedCaution(false);

    props.updateQueryCheckCompleted(false);
    setCheckedCompleted(false);

    setPage(0);
    setListData([]);
  }



  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
    props.updateRowsPerPageEmergencyHistories(event.target.value);
  };


  const handleCheckEmergency = event => {
    setCheckedEmergency(event.target.checked);
    props.updateQueryCheckEmergency(event.target.checked);
  }

  const handleCheckCaution = event => {
    setCheckedCaution(event.target.checked);
    props.updateQueryCheckCaution(event.target.checked);
  }


  const handleCheckedCompleted = event => {
    setCheckedCompleted(event.target.checked);
    props.updateQueryCheckCompleted(event.target.checked);
  }


  const startRow = (page * rowsPerPage);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    console.log("property: " + property);
  };


  return (

    //Device ID
    //위치구분 (시설 이름)
    //설치위치 (6층 A병실)
    //설치위치상세 (안쪽 모서리)
    //room 타입(bedroom bathroom, living room)
    //silent mode
    //이용자
    //  이름, 전화번호 등 인적사항
    //보호자
    //  이름, 전화번호 등 인적사항

    <Card className={clsx(classes.root, className)} {...rest} >

      <Box m={1} p={2}>

        <Box mt={2}
          display="flex"
          alignItems="center"
          justifyContent="start"
          flexGrow={1}>


          <div className={classes.input_container}>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  maxDate={moment()}
                  // maxDate={moment().subtract(1, "days")}
                  variant="inline"
                  // inputVariant="outlined"

                  id="date-picker-dialog_start"
                  format="yyyy-MM-dd"
                  fontSize="20"
                  value={startDate}
                  onChange={handleStartDateChange}
                  KeyboardButtonProps={{ 'aria-label': 'change date', }}
                  className={classes.datepicker}
                />

                <KeyboardTimePicker
                  className={classes.textField_small}
                  value={startTime}
                  onChange={handleStartTimeChange}
                  ampm={false}
                />

                <Typography variant="body1" style={{ marginLeft: '20px', marginRight: '20px' }}>~</Typography>

                <KeyboardDatePicker
                  autoOk
                  maxDate={moment()}
                  variant="inline"
                  id="date-picker-dialog_end"
                  format="yyyy-MM-dd"
                  fontSize="16"
                  value={endDate}
                  onChange={handleEndDateChange}
                  KeyboardButtonProps={{ 'aria-label': 'change date', }}
                  className={classes.datepicker}
                />

                <KeyboardTimePicker
                  className={classes.textField_small}
                  value={endTime}
                  onChange={handleEndTimeChange}
                  ampm={false}
                />

              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </div>


          <Autocomplete
            id="select-room"
            options={roomList}
            className={classes.options}
            // classes={{ option: classes.options, }}
            width={200}
            // fullWidth
            autoHighlight
            getOptionLabel={(option) => (option.roomName ? option.roomName : "")}
            getOptionSelected={(option, value) => option.roomName === value.roomName}
            value={getRoomName(selectedRoomId)}
            renderOption={(option) => (
              <React.Fragment>
                {option.roomName}
              </React.Fragment>
            )}

            renderInput={(params) => (
              <TextField
                {...params}
                label={formatMessage({id:'emergency_history_select_room'})}
                variant="outlined"
                // required
                inputProps={{
                  ...params.inputProps,
                  // autoComplete: 'new-password', // disable autocomplete and autofill
                }}
              />
            )}

            onChange={(event, newValue) => {
              if (newValue && newValue.roomId) {
                props.updateQueryEmergencyRoomId(newValue.roomId);
                setSelectedRoomId(newValue.roomId);
              }
            }}
          />


          {/* <FormGroup row style={{marginLeft:'40px'}}> */}
          <FormGroup row >

            <FormControlLabel
              control={<Switch checked={checkedEmergency} onChange={handleCheckEmergency} name="checkEmergency" color="primary" />}
              label={formatMessage({id:'emergency_board_title'})}
            />

            <FormControlLabel
              control={<Switch checked={checkedCaution} onChange={handleCheckCaution} name="checkCaution" color="primary" />}
              label={formatMessage({id:'caution_board_title'})}
            />
          </FormGroup>


          <FormControlLabel
            control={<Checkbox checked={checkedCompleted} onChange={handleCheckedCompleted} name="checkCompleted" color="primary" />}
            label={formatMessage({id:'emergency_history_act_completed'})}
            style={{ marginLeft: '10px', marginRight: '30px' }}
          />

          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.bulkAction}
            onClick={handleSearch}
          >
            {<FormattedMessage id="search" />}
          </Button>


          <Button
            variant="outlined"
            size="large"
            className={classes.bulkAction}
            onClick={handleClear}
          >
            {<FormattedMessage id="initialize" />}
          </Button>

        </Box>
      </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>

              <EnhancedTableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}

              />

              <TableBody>

                {stableSort(listData, getComparator(order, orderBy))
                .slice(0 + startRow, rowsPerPage + (page * rowsPerPage))
                .map( (module, index) => {
                  // console.log( row.roomName + ' ' + row.first_eventTime);
                  // const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      // onClick={(event) => handleClick(event, row.name)}
                      // role="checkbox"
                      // aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={module.eventId}
                      // selected={isItemSelected}
                      component={RouterLink} to={`/firstaid/update/${module.eventId}`}
                    >

                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{'aria-labelledby': labelId}}
                          />
                      </TableCell> */}

                    <TableCell  width={COLUMN_WIDTH.NO} align="center">
                        <Typography variant="body1">{module.no}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ROOM_NAME} align="left">{module.roomName}&nbsp;&nbsp;
                        <Typography variant="caption">{module.installed_pos_detail}</Typography></TableCell>

                    <TableCell width={COLUMN_WIDTH.STATUS_LABEL} align="center">
                        { module.statusLabel.includes('EMERGENCY') ?
                        (<EmergencyTextTypography>{formatMessage({id:module.statusLabel})}</EmergencyTextTypography>) :
                        (<CautionTextTypography>{formatMessage({id:module.statusLabel})}</CautionTextTypography>)
                      }</TableCell>


                    <TableCell width={COLUMN_WIDTH.FIRST_EVENTTIME} align="center">{moment(module.first_eventTime).format('MM.DD HH:mm')}</TableCell>
                    <TableCell width={COLUMN_WIDTH.OCCURFROM} align="center">
                       {module.occurFrom == '0' ? formatMessage({id:'emergency_table_occurFrom_sensor'}) : formatMessage({id:'emergency_table_occurFrom_backend'}) }
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ACTION_USER} align="center">{module.action_user}</TableCell>
                    <TableCell width={COLUMN_WIDTH.ACTION} align="center">{module.action}</TableCell>
                    <TableCell width={COLUMN_WIDTH.ACTIONTIMESTAMPNO} align="center">{ module.actionTimeStamp && moment(module.actionTimeStamp).format('MM.DD HH:mm')}</TableCell>
                    </TableRow>
                  )

                  })
                }

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

EmergencyList.propTypes = {
  className: PropTypes.string,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateQueryStartDate,
    updateQueryStartTime,
    updateQueryEndDate,
    updateQueryEndTime,
    updateQueryEmergencyRoomId,
    updateQueryCheckEmergency,
    updateQueryCheckCaution,
    updateQueryCheckCompleted,
    updateRowsPerPageEmergencyHistories
   }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryParams: state.queryParams,
    queryRowsPerPage: state.queryRowsPerPage
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EmergencyList));


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight: 20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },

  input_container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // alignContent: 'center',
  },
  datepicker: {
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // alignContent: 'center',
    // fontSize: '20px',
    marginLeft: theme.spacing(1),
    maringRight: theme.spacing(1),
    width:140,
  },

  textField: {
    marginLeft : theme.spacing(1),
    maringRight: theme.spacing(1),
    width:120,
  },
  textField_small: {
    marginLeft: theme.spacing(1),
    maringRight: theme.spacing(1),
    width: 100,
  },
  options: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    width: 260,
  }

}));